export default __webpack_public_path__ + "static/media/logo1.0ab336a6.png";